<!-- 病虫害首页 -->
<template>
  <div
    style="
      position: absolute;
      height: 100%;
      width: 100%;
      background-color: #030c3f;
      pointer-events: all;
    "
  >
    <div style="padding: 5px">
      <!-- 标题 -->
      <p style="color: #ffd0a3; font-size: 16px">草莓病虫害监测预警</p>

      <!-- 生长周期 -->
      <phase></phase>

      <!-- 天气走势 -->
      <div style="padding: 0 8px; margin: 5px 0">
        <weather></weather>
      </div>

      <!-- 各种病虫害指数 -->
      <disease-list></disease-list>
      <!--  -->
    </div>
  </div>
</template>
<script>
import DiseaseList from './list'
import Weather from './weather/index.vue'
import Phase from './phase.vue'
export default {
  components: { DiseaseList, Weather, Phase },
  data() {
    return {}
  },
}
</script>


// WEBPACK FOOTER //
// src/components/disease/index.vue